<h2 mat-dialog-title>Fehler</h2>
<mat-dialog-content style="max-width: 600px">
	<p>
		<b>Hinweis:</b><br />
		Leider ist in der Anwendung ein Fehler aufgetreten. Die nachfolgenden Informationen sind für die Fehlerbehebung
		hilfreich. Bitte geben Sie diese entsprechend weiter.
	</p>
	<p>
		<b>Fehlermeldung:</b><br />
		{{ data.message }}
	</p>
	<b>Stack Trace:</b>
	<code>
		{{ data.stackTrace }}
	</code>
	<b>Aktuelle URL:</b>
	<code>
		{{ data.currentUrl }}
	</code>
	<b>Ihr Benutzer:</b>
	<code>
		Tenant ID: {{ userData.tenantId }}<br />
		Username: {{ userData.username }}<br />
		Application Insights Trace ID: {{ aiTraceId }}<br />
	</code>
	<p>Hier können Sie den Fehler kopieren und an uns schicken:</p>
	<button matButton="filled" class="lvr-secondary" (click)="copyToClipboard()">In Zwischenablage kopieren</button>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button matButton="filled" color="warn" (click)="close()">OK</button>
</mat-dialog-actions>
